import { useEffect } from 'react';

/**
 * Hook to detect when the page is shown or restored from the back-forward cache.
 * @param callback - Function to call when the page is shown.
 */
export const usePageShow = (callback?: (event: PageTransitionEvent) => void) => {
  useEffect(() => {
    const handlePageShow = (event: PageTransitionEvent) => {
      if (callback) {
        callback(event);
      }
    };

    window.addEventListener('pageshow', handlePageShow);

    return () => {
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, [callback]);
};
